import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import MaterialFilesUploadPage from './MaterialFilesUploadPage';
import { getMaterialFiles } from 'src/actions/materialFilesAction';
import { doMaterialFileUpload, clearMaterialFiles } from 'src/actions/fileuploadAction';
import {
    saveMaterialfiles,
} from '../../actions/signupAction';
export const mapStateToProps = (state: AppState) => {
    return {
        materialFilesData: state.materialFiles.materialFilesData,
        materialprogress: state.fileUpload.materialprogress,
        materialfiles: state.fileUpload.materialfiles,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            dispatch(getMaterialFiles);
        },

        onSubmit: () => {
            dispatch(doMaterialFileUpload);
        },
        onClear: () => {
            dispatch(clearMaterialFiles);
        },
        saveMaterialfiles: (customermaterialfiles: File) => {
            dispatch(saveMaterialfiles(customermaterialfiles));
        },
    };
};

const MaterialFilesUploadPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MaterialFilesUploadPage);

export default MaterialFilesUploadPageContainer;



// WEBPACK FOOTER //
// ./src/components/MaterialFilesUpload/MaterialFilesUploadContainer.tsx